// extracted by mini-css-extract-plugin
export default {"noteContainer":"NoteCell_noteContainer__qOMPD"};